(() => {
  if (customElements.get('kpc-card')) return;

  class KpcCard extends HTMLElement {
    constructor() {
      super();
      this.mainToggle = this.querySelector('.kpc__main-toggle');
      this.activeItems = this.querySelectorAll('.kpc__active-item');
      this.inciToggle = this.querySelector('.kpc__inci-toggle');
      this.inciBody = this.querySelector('.kpc__inci-body');

      // Toggle Principal (Acordeão de toda a sessão)
      if (this.mainToggle) {
        this.mainToggle.addEventListener('click', () => {
          this.classList.toggle('is-expanded');
          const isExpanded = this.classList.contains('is-expanded');
          this.mainToggle.setAttribute('aria-expanded', isExpanded);
        });
      }

      // Toggle de Ativos (As bolinhas verdes)
      this.activeItems.forEach((item) => {
        item.addEventListener('click', () => {
          const uid = item.getAttribute('data-kpc-active');
          const detail = this.querySelector(`[data-kpc-detail="${uid}"]`);

          // Fecha os outros antes de abrir
          this.activeItems.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.classList.remove('is-open');
              const otherUid = otherItem.getAttribute('data-kpc-active');
              const otherDetail = this.querySelector(`[data-kpc-detail="${otherUid}"]`);
              if (otherDetail) otherDetail.classList.remove('is-open');
            }
          });

          // Alterna o clicado
          item.classList.toggle('is-open');
          if (detail) {
            detail.classList.toggle('is-open');
          }
        });
      });

      // Toggle da Fórmula INCI
      if (this.inciToggle && this.inciBody) {
        this.inciToggle.addEventListener('click', () => {
          this.inciBody.classList.toggle('is-open');
          const isOpen = this.inciBody.classList.contains('is-open');
          this.inciToggle.setAttribute('aria-expanded', isOpen);
        });
      }
    }
  }

  customElements.define('kpc-card', KpcCard);
})();
